import React from "react";
import Header from "../components/Header";

const Documents = ({ LeftNavRef }) => {
  return (
    <div className="w-full px-4 md:px-10 pb-10">
      <Header LeftNavRef={LeftNavRef} />
      <div className="flex justify-between items-center p-5">
        <h1 className="hidden sm:block text-lg font-normal">Documents</h1>
        <div className="flex items-center ml-auto space-x-2">
          <h1 className="text-lg font-normal">New Documents</h1>
          <button className="w-7 h-7 text-xl flex items-center justify-center rounded-full  pink-btn  text-white shadow">
            +
          </button>
        </div>
      </div>

      <div className="flex flex-wrap lg:flex-nowrap justify-start lg:justify-between lg:space-x-5 w-full">
        <div className="w-full sm:w-6/12 lg:w-4/12">
          <div className="bg-gray-100 p-3 m-3 flex flex-col shadow-2xl min-h-[320px]">
            <h2 className="text-lg font-medium text-gray-900">
              Share Document with
            </h2>
            <div className="w-full flex justify-between mt-2 mb-3">
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-900" />
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-200" />
            </div>

            <div className="space-y-3">
              <button className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white bg-gradient-to-tr  pink-btn  ">
                <span className="text-base">Employee Portal</span>
                <span className="flex items-center justify-center w-7 h-7 rounded-full  pink-btn  shadow">
                  +
                </span>
              </button>
              <button className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white bg-gradient-to-tr  pink-btn  ">
                <span className="text-base">Employer Portal</span>
                <span className="flex items-center justify-center w-7 h-7 rounded-full  pink-btn  shadow">
                  +
                </span>
              </button>
            </div>

            <div className="flex justify-between mt-auto">
              <div className="w-4/12 text-center">
                <h2 className="text-lg -mb-2">23</h2>
                <small>Total</small>
              </div>
              <div className="w-4/12 text-center border-l-2 border-r-2">
                <h2 className="text-lg -mb-2">5</h2>
                <small>New Ones</small>
              </div>
              <div className="w-4/12 text-center">
                <h2 className="text-lg -mb-2">27</h2>
                <small>Overrall</small>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full sm:w-6/12 lg:w-4/12">
          <div className="bg-gray-100 p-3 m-3 flex flex-col shadow-2xl min-h-[320px]">
            <h2 className="text-lg font-medium text-gray-900">
              Share Document with
            </h2>
            <div className="w-full flex justify-between mt-2 mb-3">
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-900" />
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-200" />
            </div>

            <div className="space-y-3">
              <button className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white bg-gradient-to-tr  pink-btn  ">
                <span className="text-sm">View</span>
                <span className="flex items-center justify-center w-7 h-7 rounded-full  pink-btn  shadow">
                  +
                </span>
              </button>
              <button className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white bg-gradient-to-tr  pink-btn  ">
                <span className="text-sm">Documents Completed</span>
                <span className="flex items-center justify-center w-7 h-7 rounded-full  pink-btn  shadow">
                  +
                </span>
              </button>
            </div>
            <div className="flex justify-between mt-auto">
              <div className="w-4/12 text-center">
                <h2 className="text-lg -mb-2">23</h2>
                <small>Total</small>
              </div>
              <div className="w-4/12 text-center border-l-2 border-r-2">
                <h2 className="text-lg -mb-2">5</h2>
                <small>New Ones</small>
              </div>
              <div className="w-4/12 text-center">
                <h2 className="text-lg -mb-2">27</h2>
                <small>Overrall</small>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full sm:w-6/12 lg:w-4/12">
          <div className="bg-gray-100 p-3 m-3 flex flex-col shadow-2xl min-h-[320px]">
            <h2 className="text-lg font-medium text-gray-900">
              Share Document with
            </h2>
            <div className="w-full flex justify-between mt-2 mb-3">
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-900" />
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-200" />
            </div>

            <div className="space-y-3">
              <button className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white bg-gradient-to-tr  pink-btn  ">
                <span className="text-sm">New Contact</span>
                <span className="flex items-center justify-center w-7 h-7 rounded-full  pink-btn  shadow">
                  +
                </span>
              </button>
              <button className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white bg-gradient-to-tr  pink-btn  ">
                <span className="text-sm">Terms and Condition</span>
                <span className="flex items-center justify-center w-7 h-7 rounded-full  pink-btn  shadow">
                  +
                </span>
              </button>
              <button className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white bg-gradient-to-tr  pink-btn  ">
                <span className="text-sm">PandaDoc</span>
                <span className="flex items-center justify-center w-7 h-7 rounded-full  pink-btn  shadow">
                  +
                </span>
              </button>
            </div>
            <div className="flex justify-between mt-auto">
              <div className="w-4/12 text-center">
                <h2 className="text-lg -mb-2">23</h2>
                <small>Total</small>
              </div>
              <div className="w-4/12 text-center border-l-2 border-r-2">
                <h2 className="text-lg -mb-2">5</h2>
                <small>New Ones</small>
              </div>
              <div className="w-4/12 text-center">
                <h2 className="text-lg -mb-2">27</h2>
                <small>Overrall</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documents;
